// The vertical KPI rail beside the network diagram: label, deep-linked
// value, delta chip vs the previous run, and a one-line source note, with a
// 13-week in-stock-rate sparkline at the bottom.
import { SnapshotKpi } from "./types";
import {
  DeltaChip,
  EM_DASH,
  LinkVal,
  Sparkline,
  fmtMetric,
  useSnapshotTokens,
} from "./primitives";

const KpiRow = ({ kpi }: { kpi: SnapshotKpi }) => {
  const t = useSnapshotTokens();
  const value = (
    <span
      style={{
        fontSize: 23,
        fontWeight: 700,
        letterSpacing: -0.6,
        color: kpi.current == null ? t.ink4 : t.ink,
      }}
      title={kpi.current == null ? kpi.missingReason : undefined}
    >
      {kpi.current != null && kpi.unitLabel && kpi.unit === "w"
        ? kpi.current.toFixed(1) + kpi.unitLabel
        : fmtMetric(kpi)}
    </span>
  );
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        padding: "11px 0",
        borderBottom: `1px solid ${t.line2}`,
      }}
    >
      <span style={{ fontSize: 11, color: t.ink3, fontWeight: 600 }}>
        {kpi.label}
      </span>
      <div style={{ display: "flex", alignItems: "baseline", gap: 9 }}>
        {kpi.current == null ? (
          value
        ) : (
          <LinkVal to={kpi.linkPath} label={kpi.linkLabel}>
            {value}
          </LinkVal>
        )}
        <DeltaChip
          current={kpi.current}
          prev={kpi.prev}
          unit={kpi.unit}
          unitLabel={kpi.unitLabel}
          good={kpi.good}
        />
      </div>
      <span style={{ fontSize: 10.5, color: t.ink4 }}>{kpi.note}</span>
    </div>
  );
};

export const KpiRail = ({
  kpis,
  inStockTrend,
}: {
  kpis: SnapshotKpi[];
  inStockTrend: number[];
}) => {
  const t = useSnapshotTokens();
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          fontSize: 10.5,
          fontWeight: 700,
          letterSpacing: 0.5,
          textTransform: "uppercase",
          color: t.ink4,
          marginBottom: 4,
        }}
      >
        Network totals
      </div>
      {kpis.map((kpi) => (
        <KpiRow key={kpi.id} kpi={kpi} />
      ))}
      <div style={{ marginTop: 12 }}>
        <div style={{ fontSize: 10.5, color: t.ink4, marginBottom: 5 }}>
          In-stock rate · 13 weeks
        </div>
        {inStockTrend.length ? (
          <Sparkline
            values={inStockTrend}
            w={230}
            h={44}
            color={t.orangeInk}
            fill
            rangeFit
          />
        ) : (
          <span
            title="No in-stock-rate trend available for this run"
            style={{ fontSize: 12, color: t.ink4 }}
          >
            {EM_DASH}
          </span>
        )}
      </div>
    </div>
  );
};
